import React from "react";
import ReactDOM from "react-dom";
import "./style/index.css";
import App from "./App";
import Recarga from "./Recarga";
import MeusDados from "./MeusDados";
import Portabilidade from "./portabilidade";
import * as serviceWorker from "./serviceWorker";
import { BrowserRouter, Switch, Route } from "react-router-dom"; // importando o BrowserRouter do pacote que acabamos de instalar

/* if(~window.location.href.toLowerCase().indexOf('portabilidade')){
    ReactDOM.render(<Portabilidade/>, document.getElementById('root'));
}
else {
    ReactDOM.render(<BrowserRouter basename="/AlgarRecarga" >
        <Switch>
            <Route path="/Recarga"  component={Recarga} />
            <Route path="/MeusDados"  component={MeusDados} />
            <Route path="/portabilidade"  component={Portabilidade} />
            <Route path="/"  component={App} />
        </Switch>
    </ BrowserRouter>, document.getElementById('root'));
} */

ReactDOM.render(
  <BrowserRouter basename="/AlgarRecarga">
    <Switch>
      <Route path="/Recarga" component={Recarga} />
      <Route path="/MeusDados" component={MeusDados} />
      <Route path="/" component={App} />
    </Switch>
  </BrowserRouter>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
